import type { PropsWithChildren } from "react";
import classNames from "classnames";

interface MainMobileProp {
  className?: string;
}

export const MainMobile = ({
  children,
  className = "",
  ...rest
}: PropsWithChildren<MainMobileProp>) => (
  <main
    className={classNames("bg-secondary grid-in-main size-full", className)}
    {...rest}
  >
    <div className="flex size-full items-center justify-center">{children}</div>
  </main>
);
